import {
  CUSTOMER_CREATE_REQUEST_FAIL,
  CUSTOMER_CREATE_REQUEST_SUCCESS,
  CUSTOMER_DELETE_REQUEST_FAIL,
  CUSTOMER_DELETE_REQUEST_SUCCESS,
  CUSTOMER_FIND_REQUEST_FAIL,
  CUSTOMER_FIND_REQUEST_SUCCESS,
  CUSTOMER_UPDATE_REQUEST_FAIL,
  CUSTOMER_UPDATE_REQUEST_SUCCESS,
  SELECT_CUSTOMER
} from '../action.types';
import initialValue from '../initial.state';

export default function(state = initialValue.customer, action) {
  switch (action.type) {
    case SELECT_CUSTOMER:
      return { ...action.customer };
    case CUSTOMER_CREATE_REQUEST_SUCCESS:
      return state;
    case CUSTOMER_CREATE_REQUEST_FAIL:
      return state;
    case CUSTOMER_UPDATE_REQUEST_SUCCESS:
      return state;
    case CUSTOMER_UPDATE_REQUEST_FAIL:
      return state;
    case CUSTOMER_DELETE_REQUEST_SUCCESS:
      return state;
    case CUSTOMER_DELETE_REQUEST_FAIL:
      return state;
    case CUSTOMER_FIND_REQUEST_SUCCESS:
      return { ...action.payload };
    case CUSTOMER_FIND_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/customer/customer.reducer.js